
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment-calculator",
      function () {
        return require("private-next-pages/payment-calculator.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payment-calculator"])
      });
    }
  